import React from 'react';
import { Search } from 'lucide-react';
import '../../styles/enterprise.css';

/**
 * Right-aligned search input matching the enterprise kit (.ent-search).
 * Controlled. Pass straight into <FilterTabs right={...} />.
 *
 * <EntSearch value={q} onChange={setQ} placeholder="Search by hash, email, amount…" />
 */
const EntSearch = ({ value, onChange, placeholder = 'Search…' }) => (
  <span className="ent-search">
    <Search aria-hidden="true" />
    <input
      type="text"
      value={value}
      onChange={(e) => onChange && onChange(e.target.value)}
      placeholder={placeholder}
    />
  </span>
);

export default EntSearch;
